export default "/images/shortage_qty.png?34bfae7fa38fbe60aaee93bb797d9b02";